export default __webpack_public_path__ + "static/media/air_meddigital.8c2c061d.webp";